import React from "react";
import './ImageUrlInput.css'
const ImageUrlInput=({onIPchange,onBTNclick,name,entries})=>{
    return(
        <div>
            
            <div className="center">
            <div className="center form br3 ma3 pa4 shadow-5 ">
                <input type='text' onChange={onIPchange} className="f4 w-70 center" />
                <button className="f4 grow w-30 br3 mh3 pa2 link bg-light-purple shadow-5 ba b--near-white pointer" onClick={onBTNclick}>Detect</button>
            </div>
            </div>
        </div>
    )
}
export default ImageUrlInput